import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { getRoute, getReferringSession, loading } from '../../../actions/sessions';
import { asyncActions } from '../../../actions/general';
import { getUser } from '../../../actions/users';
import { updateApplication } from '../../../actions/applications';
import UserRecord from '../../../records/user';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useSessionEntity from '../../../hooks/useSessionEntity';
import Loading from '../../shared/Loading';
import Error from '../../shared/Error';

export default function AuthorizePurchaser({location}) {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.sessions.get('loading'));
  const application = useSessionEntity('application');
  const [user, setUser] = useState(null);
  const [purchaser, isPurchaser] = useState(true);

  useRouteStatus(location);

  useEffect(() => {
    dispatch(getReferringSession())
      .then(session => dispatch(getUser(session.depId('user'), true)))
      .then(user => setUser(new UserRecord(user.data.attributes)));
  }, []);

  const save = () => {
    dispatch(loading(true));
    dispatch(asyncActions(
      updateApplication(application.set('has_authorized_purchaser', purchaser)),
      getRoute()
    ))
    .then(res => dispatch(loading(false)));
  }

  if (!user) return (<Loading />);

  return (
    <div id="content">
      <div className="is-size-4 has-text-weight-semibold">Authorize {user.first_name} {user.last_name} for future purchases?</div>

      <Error />

      <div className="mb-6">
        <div className="field">
          <input type="radio" className="is-checkradio" id="has_authorized_purchaser" name="has_authorized_purchaser" onChange={() => isPurchaser(true)} value={purchaser} checked={purchaser} />
          <label htmlFor="has_authorized_purchaser">I authorize {user.first_name} {user.last_name} to sign on behalf of {application.company_name}</label>
        </div>

        <div className="field">
          <input type="radio" className="is-checkradio" id="is_not_authorized_purchaser" name="has_authorized_purchaser" onChange={() => isPurchaser(false)} value={purchaser} checked={!purchaser} />
          <label htmlFor="is_not_authorized_purchaser">I would like to approve each purchase separately</label>
        </div>
      </div>

      <button
        type="submit"
        role="submit"
        disabled={isLoading}
        className={classNames('button is-primary is-large is-fullwidth has-text-weight-bold', {
          'is-loading': isLoading
        })}
        onClick={save}>
          Next
      </button>
    </div>
  )
}
